// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pZRc-","left":"styles_left__3oUsf"};